<template>
  <div v-if="data && q">
    <nav class="navbar fixed-top">
      <router-link to="/" :class="disableHref ? 'disabled-href' : ''">
        <img src="@/assets/img/checkme_logo.svg?data"
             alt="CheckMe logo"
             class="img-logo img-fluid" />
      </router-link>
      <button class="text-center cursor-pointer env--small"
              v-if="env === 'dev' || env === 'qa'" @click="clearStorage()">
        clear storage
      </button>
      <small class="text-center env--small" v-if="env === 'dev' || env === 'qa'">Miljö: {{ env }}</small>
      <div>
        <div class="radio-buttons-container">
          <div v-for="(code, lang) in q.top.languageList" :key="code" class="radio-button-item">
            <input type="radio" :id="'language_' + code" :value="code" v-model="language">
            <label :for="'language_' + code" class="language-label" style="font-size:small">{{ lang }}</label>
          </div>
        </div>
      </div>
      <img src="@/assets/img/hamburger.svg?data"
           alt="Ikon för hamburgarmeny"
           class="navbar-toggler img-fluid"
           data-toggle="collapse"
           data-target="#collapsibleNavbar" />
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <hr />
        <ul class="navbar-nav">
          <li class="nav-item">
            <a href="/" :class="disableHref ? 'disabled-href' : ''"
               class="nav-link text-primary" v-html="data.faq.topHeaderStart"></a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link text-primary"
                         data-toggle="collapse"
                         data-target="#collapsibleNavbar"
                         :to="{ name: 'faq', params: { page: pages.aboutapp } }"
                         v-html="data.faq.topHeaderAbout">
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link text-primary"
                         data-toggle="collapse"
                         data-target="#collapsibleNavbar"
                         :to="{ name: 'faq', params: { page: pages.cookies } }"
                         v-html="data.faq.cookiesHeader">
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link text-primary"
                         data-toggle="collapse"
                         data-target="#collapsibleNavbar"
                         :to="{ name: 'faq', params: { page: pages.contact } }"
                         v-html="data.faq.topHeaderContact">
            </router-link>
          </li>
          <div class="dropdown-divider" v-if="notRootOrLogin() && doesTokenExist()"></div>
          <li class="nav-item" v-if="notRootOrLogin() && doesTokenExist()">
            <span class="nav-link text-primary cursor-pointer"
                  data-toggle="collapse"
                  data-target="#collapsibleNavbar"
                  @click="logOut()">
              <strong>Logga ut</strong>
            </span>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'top',
  data () {
    return {
      data: null,
      disableHref: false,
      q: null,
      pages: {
        aboutapp: 'aboutapp',
        contact: 'contact',
        cookies: 'cookies'
      },
      language: sessionStorage.getItem('language'),
      env: process.env.NODE_ENV
    }
  },
  computed: {
    isDashboardOrFamilytree () {
      return this.$route.name === 'dashboard' ||
      this.$route.name === 'dashboardnf' ||
      this.$route.name === 'familytree'
    }
  },
  methods: {
    clearStorage () {
      localStorage.clear()
      sessionStorage.clear()
      location.reload()
    },
    logOut () {
      sessionStorage.clear()
      document.location.href = '/'
    },
    notRootOrLogin () {
      return location.pathname !== '/' && location.pathname !== '/login-tr'
    },
    doesTokenExist () {
      if (sessionStorage.hasOwnProperty('jwt')) {
        return true
      }
    }
  },
  watch: {
    language (l) {
      if (l) {
        this.language = l
        sessionStorage.setItem('language', this.language)
        location.reload()
      }
    }
  },
  async beforeMount () {
    this.q = await request({
      query: `
      {
        top {
          languageList
        }
      }
      `
    })
    /* We get languagelist from DatoCMS, check if {l} in query param ?language={l}, ex: ?language=ar, is
       included in the list and then set the language to that. Otherwise we want to use english as
       fallback or accept the choice from dropdown that the user interacts with
    */
    if (this.q && Object.values(this.q.top.languageList).includes(this.$route.query.language)) {
      this.language = this.$route.query.language
      sessionStorage.setItem('language', this.language)
    } else if (!sessionStorage.getItem('language')) {
      this.language = 'sv'
      sessionStorage.setItem('language', this.language)
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          faq(locale: ` + this.language + `) {
            topHeaderAbout
            topHeaderContact
            topHeaderStart
            cookiesHeader
          }
        }
      `
    })
    $(document).on('click', function () {
      $('#collapsibleNavbar').collapse('hide')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
nav {
  background: #B1DDC9 !important;
  filter: drop-shadow(4px 4px 14px rgba(224, 208, 192, 0.73));
}
.radio-buttons-container {
  display: flex;
  flex-direction: row; /* Ensure items are in a row */
}
.radio-button-item {
  display: flex;
  /*align-items: center;*/ /* Align items vertically */
  vertical-align: middle;
  margin-right: 10px; /* Adjust as needed */
  margin-top: 5px;
}
input[type="radio"]{vertical-align: middle;appearance:none;}
.language-label {
    margin-left: 5px; /* Adjust as needed to create space between radio button and label */
    vertical-align: middle;
}
  .language-select {
    cursor: pointer;
    width: 6vw;
    height: 3vh;
    padding: 2px;
    margin-right: 10px;
    text-align: right;
    border: 0;
    outline: 0;
    background: transparent;
    -webkit-appearance: none;
  }
.language-select-prod {
  position: absolute;
  top: 14px;
  right: 80px;
}
.nav-item {
  text-align: right;
}
.navbar-toggler {
  cursor: pointer;
  border: 0;
}
.navbar-span {
  margin-left: .5em;
}
.nav-link {
  font-size: 20px;
  float: right;
  margin-left: 10px;
}
.cursor-pointer {
  cursor: pointer;
}
.disabled-href {
  opacity: 0.3;
  pointer-events: none;
}
.env--small {
  padding: 0.5vh 2.2vw 0.5vh 2.2vw;
  border-radius: 8px;
  font-size: 10px;
  background: #F7FFF7;
}
.img-logo {
  width: 10vw;
}
@media screen and (min-width: 800px) {
  .header {
    height: 55px;
  }
}
@media screen and (max-width: 1000px) {
  .navbar-tahoma {
    font-size: 20px;
    vertical-align: middle;
  }
  .header {
    margin-left: 100px;
  }
  .skanelogo {
    max-width: 15%;
  }
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .env--small {
    display: none;
  }
  .img-logo {
    width: 30vw;
  }
  .header {
    display: none;
  }
  .navbar-toggler {
    width: 15vw;
  }
  .language-select {
    width: 22vw;
    height: 4vh;
    font-size:14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue